import { getPhoneNumber } from '@/utils'

export default {
  mobileHome: {
    mainSection: '热爱我们所做的',
    creativity: {
      title: '合理的创意',
      paragraphs: [
        '我们是圣保罗的一家律师事务所，是一个有创意及创新的职业团队，专业是为客户提供策略、咨询与建议。主要是为企业及艺人提供服务，服务的范围包括代里客户、提供意见、帮助解决问题、执行所需的事务、保护客户的权益及为客户进行所需的控诉。',
        'Onesti Advogados 律师事务所支持客户及提高客户的价值，让客户能够集中精力做所擅长的，手续方面就留给我们为您处理。',
        '我们对法律信任及对我们为您提供的解决方案有信心。以创意及创新让您所签署的合同能够为您带来实际的利益。我们将与您一同策划解决方案，而不是单方面的把方案硬推给您。我们执行我们的承诺。'
      ],
      footer: '#DesignThinking'
    },
    solutions: {
      title: '解决方案',
      paragraphs: [
        '简而言之，为了方便您的工作为您量身订制所需的代理方式。我们的建议是：'
      ],
      list: [
        '协助成立公司与帮助计划新的企业；',
        '为您的生意带来创意、创新及策略；',
        '对您的利益进行规划与保护；',
        '协助您与客户、供应商、特殊人才、员工、有影响力者及其他人之间的交易与签约；',
        '协助您，为您的事业提供建议与指导。'
      ],
      footer: {
        hashTag: '#WeDeliver',
        slogan: {
          firstPiece: 'Fazemos o que',
          mainWord: 'Amamos',
          lastPiece: 'O que fazemos'
        }
      }
    },
    bio: {
      title: 'Bio',
      paragraphs: [
        '一个创意与创新的事务所是不寻常的。我们好奇。我们的到来为这领域带来了不同。我们注重人的价值，帮助不营利组织，以自愿者身份参与各种领域。这些经验，在为客户寻求解决方案时，能够为我们提供宝贵的建议与技能。',
        '如此，我们的工作者、客户及合作者以一个特殊方式组成一个团体来做对的事情，以价值观与原则来实践我们的理想。',
        '事务所的收费方式透明及简易，不停的观看时间对建立双方的信任与合作是不利的。',
        '高效的律师事务的交流渠道必须是畅通的。让客户少花钱而能够为他多办事。律师行业的创新不只是有好的想法，还需要让想法能够转换为价值给客户。',
        '简而言之，简单、快速与策略的作风加上对客户需求的了解及适当的价格为有意义的解决方案原则。'
      ],
      footer: '#我们是为这而生的'
    },
    footer: {
      buttonLabel: 'Visite a versão completa do site',
      hashTag: '#WeSpeakYourLanguage',
      sayHi: 'Say Hi',
      paragraphs: [
        'Soluções estratégicas, inteligentes e inovadoras. Uma combinação mágica de habilidades legais e empresariais. Nossos ideais de parceria e dedicação são a base para um relacionamento próximo, transparente, sólido e duradouro, construído por meio da confiança e amizade. Essa é a nossa paixão.'
      ]
    }
  },
  presentation: {
    title: '一个焦距于看法、解决问题及注重人际关系的办公室',
    text: '相信我们的工作成绩能够替代我们的言语。上网浏览一下我们的历史、文化背景、所解决的案件和认识我们的工作态度是用心及对细节的'
  },
  slogan: '我们属于我们所做的',
  navBar: {
    title: 'Menu',
    language: '语言',
    menuTitle: {
      office: 'Office',
      practice: 'Practice',
      recognition: 'Recognition',
      socialMedia: 'Media'
    },
    subMenu: {
      office: [
        ['我们是唯一的', 'Why us'],
        ['我们从哪儿来的', 'History'],
        ['看到了什么', 'Vision'],
        ['我们的想法', 'Politics'],
        ['如何生活', 'Values'],
        ['如何处理事务', 'Responsibilities']
      ],
      practice: [
        ['我们有什么', 'Base'],
        ['为您准备好了', 'Structure'],
        ['解决方案', 'Solutions'],
        ['工作范围', 'Field']
      ],
      recognition: [
        ['从何而来', 'Media'],
        ['成功的例子', 'Achievements']
      ]
    }
  },
  unique: {
    title: '我们是唯一的',
    subtitle: '这不仅是看，而是需要经历它',
    paragraphs: [
      '我们已经准备好了来创造不同。我们的知识超越了书籍与法律条款所提供的；在长久的岁月里我们累积了许多专业经验。我们相信人的价值及他的多样性，能够带来创意、互助与承诺。我们的想法是全面性的，一种商业与法律能力的完美结合。',
      '我们不只是代表您，我们要（必须）认识（了解）您的生意，才能够提供您所需要的。我们与您共同制定方案而不是单方面我们的把方案推给您，如此，我们共同创新，以相互帮助的方式来达到长远的合作。我们的想法是以伙伴的关系与奉献的精神为基础，通过密切的交流，以透明、坚定与持久的关系建立信任与友谊。这是我们所热衷的。没有您就没有我们的存在。胜利在我们的血液里。',
      '我们的交流是灵活的及高效的，以简单、透明与清晰的方式传递信息。我们全天候的聆听您要讲的。',
      '简而言之，以简洁、快速、及策略的作风加上对需求的了解还有适当的价格来为您提供量身的方案。',
      '以这背景，让您不需要分心而专注于您擅长的强项。没有偏见与束缚，我们承认是一直在错误中学习，不停的创新而不把自己关闭于狭窄的思潮里。'
    ]
  },
  from: {
    title: '我们从哪儿来的',
    subtitle: '从梦想到策略',
    paragraphs: [
      '我们的历史开始于2004年，诞生了OLN Advogados律师事务所。几年后，股东Murillo Onesti，累积了多年的经验，决定寻找不同的概念来经营律师事务，他对新颖的企业经营方式进行多方面的研究，决定创立Onesti Advogados律师事务所。',
      '这是一条漫长的道路，在揭开古典律法实践的神秘面纱的途径曾遇到许多不同的挑战，有时获胜有时挫败，不论在交易、风险控制、策略方向、咨询或争议我们的作风是简明的、新潮的及容易接触的。这份经验加上我们的基本信念，让我们发展了自己的文化，就是焦距于客户，彰显人的价值及不停的研究，以简明、创新的工作方式及不断地吸收人才与科技。',
      '我们以持续及有意义的方式为个人或集体的发展提供多元化的工具。我们的理念与企业所需的法律经验的结合带来一种美好的及不多见的组合。',
      '我们的成长体现了与客户保持良好长期的合作关系，基础于信任、合作与友谊。不停的追求知识及学习行业的细节，来准确的断定需求及对细节的主意，为客户制定量身的解决方案。',
      '以有策略与智慧的方式对律师事务的执行进行创新。'
    ]
  },
  been: {
    title: '从何而来',
    subtitle: '认可与证据'
  },
  see: {
    title: '看到了什么',
    subtitle: '卓越的管理',
    paragraphs: [
      '信息时代结合了技术发展，让消费者对新奇事物的关注及使他们变得更理智及要求更高。由于受客户直接参与创造和生产，使其流程变得更加民主。这类新消费者带来了个性化和高效的服务的需求，以公平的价格和灵活的服务来满足他们的需求与期望。',
      '这些因素在现代化的竞争市场将使企业及专业人士脱颖而出，为其客户寻找合适的供应商来解决问题及为客户的事业增加价值。',
      '律师行业不论传统是多么的丰富多彩多姿，它需要跟随潮流的更变、发展及调节来适应这些新客户的要求。企业管理、企业文化及如何对待科技将为律师事务所提供的服务带来影响。将使处理案件的效率提高及更加经济。律师事务所的创新不只是好念头，这投资将转换成价值回馈给客户。',
      '从事务所成立以来就有这愿望不断地走在时代的前面，与客户共同寻求适当成本的高效及创新的解决方案。',
      '重视反馈是学习的泉源。我们的适应性，创造力，多功能性，工作效率，敏捷性，创新与尝试的愿意和接受不完美为我们的动力。'
    ]
  },
  think: {
    title: '我们的想法',
    subtitle: '自由',
    paragraphs: [
      '与我们的工作人员、客户及伙伴们组成合作共同体，以我们的价值观与处事原则所制定的理想，一种特殊的处理案件方式。'
    ],
    accordions: [
      {
        title: '使命',
        subtitle: '魅力，创造，投资，创新，改进，发展和激励',
        text: ['倾听客户及征服我们的客户。我们所做的能够为客户产生价值。我们投资于人及科技。我们服务的创新由于提供高效率及个人化的服务，激发我们的工作环境，以责任、效率、道德及可持续性管理方式营运我们的业务。']
      },
      {
        title: '愿景',
        subtitle: '人, 社会, 成长， 品质, 人, 利润, 创造力',
        text: [
          '先进的写字楼,行事基础是我们的价值观与理念，以高效率、质量与创新的精神提供解决方案及重视人际关系与培养人才。',
          '高产能、高效率、精益和积极、注重承诺来服务社会。行事简单明了。以品质与持续成长为基础。对我们说来最重要的是起点而不是终点。'
        ]
      },
      {
        title: '战略',
        subtitle: '效率，敏捷，行动，创造力，创新，团队，价值，独家',
        text: ['培养我们的人才，专注他们的团队精神，让他们的行为习惯于创新、高效及负责任。结合个人经验与知识。使用的技术与所提供的服务保持一致。 与客户一起工作，了解他们的业务并了解他们的思维方式。理智的创新不担心犯错。寻求克服挑战，在失败中学习。致力于高效，低成本的管理。展示人力资源的调动能力。']
      }
    ]
  },
  live: {
    title: '如何生活',
    subtitle: '创造机会',
    accordions: [
      {
        title: '创新',
        subtitle: '挑战、创造、发明、研究。',
        text: ['我们的目标是在不担心犯错的情况下寻求与众不同、独家的、创造力与效率、分享经验，想法为结果带来差异，甚至从法律外寻找灵感。以灵活性与多功能性打破成规。以最经济的方式获得最高的成果。']
      },
      {
        title: '品质',
        subtitle: '效率，重点于克服，决心，成绩。',
        text: [
          '在所作的事情上取得卓越的成就，做到我们的最好，从错误中学习，克服挑战。以行动履行我们的承诺。不断地成长，为客户提供灵活、创新、高效和独特的结果。'
        ]
      },
      {
        title: '聚焦于客户',
        subtitle: '成绩、关系、互动、独一、兴趣、学习。',
        text: [
          '我们有决心。挑战古旧的想法，在没有实验的情况下进行创新。对客户的每项业务进行研究，了解客户的需求与期望。定制高效，创新的解决方案，为客户的业务增添价值。对自己的工作充满热情，努力确保客户最高的利益，避免客户分心而专注他的擅长。在尊重和友谊的基础上追求长期和持久的关系。永远为您服务。'
        ]
      },
      {
        title: '清楚',
        subtitle: '诚信、透明、高效、沟通、解释、评估。',
        text: [
          '与客户简单有效的沟通来感觉客户的需求，以敏捷及具体的答复来满足客户所遇到的困难与挑战。我们化繁为简能够为客户提供多方面的服务。让客户觉得律师事务变得简易及容易接受。'
        ]
      },
      {
        title: '独立',
        subtitle: '自由，多面性，透明度，灵活性，社会，道德，伙伴关系。',
        text: [
          '我们很自豪是一家巴西律师事务所，融入当地社会，能够长期支持与帮助所处的社会。以透明的方式及职业道德执行我们的律师业务而不听命他人，完全致力于我们的客户及其业务。没有偏见与束缚，我们从错误中学习，不断地加强办事能力。'
        ]
      },
      {
        title: '协助',
        subtitle: '激情，快乐，分享，友谊，联盟，参与，态度。',
        text: [
          '我们喜欢人与人的交往。我们的重点是聚集人才。我们鼓励结盟、团体工作、相互尊重、优点分工及经验交流。我们的工作基础于团结与忠诚及健康的竞争。促进工作者的成长与不断地进步，在服务上保持道德与公正。对业务的热情，以业主的立场为客户服务。支持内部人员的创业活动。'
        ]
      }
    ]
  },
  practice: {
    title: '如何处理事务',
    subtitle: '不只是看，还要经验生活',
    paragraphs: [
      '实践我们所宣扬的。相信真正创新，我们必须考虑整体及超越我们目前的作为。这就是为什么我们将社会和道德责任纳入我们的工作，以透明和理智的方式管理我们的业务，始终以满足与我们直接或间接交往的不同客户的需求与期望为目的。采用可持续的方式贡献社会，有义务让它变得更公正与更进步。所采取的举措中，我们强调：'
    ],
    accordions: [
      {
        name: 'liability',
        title: '对环境的责任',
        subtitle: '让世界变得更好及可持续发展',
        text: [
          '我们了解我们对社会及生活的环境带来的影响。知道只是消费认证的产品是不够的。有必须理智及智慧的消费。我们需要多思考产品的多次使用、回收及减少消耗的可能性。发展经济与社会务必考虑环境保护。在我们的生活中，促进和鼓励可持续的举动，不断质疑何处可以改进，简化和更有责任感。',
          '可持续性的管理意味着需要投资于软件与现代化的设备，让我们的工作简单化及更加灵活，这包括低消耗能量、资源与材料。鼓励使用电子和数字媒体',
          '我们相信寻求更美好和可持续的世界的信念。'
        ]
      },
      {
        name: 'pro-bono',
        title: '免费服务',
        subtitle: '正能量! 帮助别人就是帮助自己',
        text: [
          '往好处想! 相信创新加上每人每天的努力能够为社会带来很大的利益。所有都开始于我们的社区，承诺除了免费服务还包括法律知识的提供。',
          '捐出时间来改善我们周围的世界。以同样的承诺、重要性、注意力和看重给予付费案件的处理。实践这一切的主要方法之一是通过协会、组织和其他实体合作，共同探索那些我们无法单独实现的目标。我们根据能够带来变化并对社区产生积极影响的能力来评估选择合作伙伴。除了这些伙伴关系，我们还保证让有需要但有困难的人能够获得司法服务;我们参与福利、教育、捐赠、食品和衣物等活动。',
          '为我们所做的工作感到非常自豪，如发展的人际关系和提供的机会。不含任何虚假，我们知道与社会的交换，提高了我们的专业水平，让我们获得了足够的经验给提供的服务带来高水准、创新与效率。我们意识到，帮助别人就是帮助自己。'
        ]
      },
      {
        name: 'diversity',
        title: '多样性和包容性',
        subtitle: '做一个真实的你，做你喜欢的事。',
        text: [
          '你是独一的。你是真实的。做你自己。做一个真实的你，做你喜欢的事。包容性和多样性激发了创新。伟大的想法可以推动世界，随时随地都可能出现。在这里，我们不仅接受差异，还支持和促进它的到来，这能够为员工、客户、提供的服务和社区带来利益。',
          '我们毫不怀疑经验和想法不同的人聚集在一起将为客户和办公室带来更具创意和创新的解决方案。因此，当我们尽最大努力促进多元化，通过法律思维的创新间接的为客户提供最高水平的服务也让所服务的社区获益。',
          '我们意识到只靠多样性带来的受益是不能持久的，除非我们尽自己的努力，鼓励新的和不同的观点、解决方案和想法。策略的一部份为改变我们的文化，加强员工的独立性，扩张发展我们的才华，让客户赞赏我们的服务。',
          '多样性改善了我们，增强了我们适应、竞争和变革的能力。相同点和不同点是我们力量的源泉。',
          '我们为我们取得的进步感到自豪，我们对多样性的承诺是不可动摇的。但知道还有许多需要改进的。我们不断努力打破障碍，改善生活，加强社区，为客户提供创新、创造和高效的解决方案，激励所有年龄、性别和技能的人。在这里你可以是你自己。我们为我们取得的进步感到自豪，我们对多样性的承诺是不可动摇的。但知道还有许多需要改进的。我们不断努力打破障碍，改善生活，加强社区，为客户提供创新、创造和高效的解决方案，激励所有年龄、性别和技能的人。在这里你可以是你自己。'
        ]
      },
      {
        name: 'career',
        title: '职业生涯',
        subtitle: '对我们来说，才华是必需的，西装不是必需的。',
        text: [
          '无论你做什么或在哪里做的都没关系。正是人才带来不同，而我们共同努力使我们与众不同。我们是多才多艺、高要求、理想主义的拥护者。我们一直在寻找最好的，还有自由和责任。我们拥有独特的工作文化，鼓励创新和创业。这激励着我们，推动我们去实践，并鼓励我们每天挑战现状。',
          '我们对好奇贪得无厌，寻求不断地学习。我们寻找并接受风险，在彼此的想法下进行创造。我们一起是很棒的。当犯错时，互相支持，共同承担风险，一同向前看齐，因为我们知道失败的道路与成功与创新是属同一途径。',
          '我们相信工作场所对生产力、相互帮助和灵感有积极影响。因此，当你试图突破创新和创造力的临界时，工作空间不能只是一个单调米色海湾的迷宫。职业生涯和职业发展相互依赖，但我们一定会站在您那边支持您，无论您需要什么。',
          '我们相信，如果雇用优秀的员工并激励他们参与公司的理念，将有更多的人依附公司的理念。所有的人都一样，他们的兴趣和需求在他们的一生中是不断的成长。同样，我们会定期评估我们提供的福利，它必需适应我们员工的需求。在这里福利是可以公开谈的，你的反馈是方程式的一部分。员工对我们是很珍贵的，所以我们供应的不只是基础需要。不断寻求进步，让企业成为一个多样性文化的聪明才智聚集地;在这儿你能够做一个真实的你。',
          '我们的文化就是我们的一切。我们知道我们要往哪里去及如何到达那里。我们是多样性的企业及做了承诺要对招聘、提高生产力和业务流程进行创新。这里每个人都是平等的、一体的，所有的人都被类似的理念、哲理与价值观连串在一起。我们推行平等政策，致力于包容和多样化。采取让所有候选人有平等的就业和晋升机会，包括少数民族、妇女、受保护的退伍军人和残疾人士。'
        ]
      }
    ]
  },
  have: {
    title: '我们有什么',
    subtitle: '期待的什么是最好的',
    paragraphs: [
      '我们拥有先进的个人和技术结构，为客户提供能力和效率。我们致力于寻找合适的解决方案，创新，创造和高效，为我们的客户提供最好和独特的解决方案。这想法带来我们的办公室处于现代化和战略性的位置，靠近商业中心，舒适，便捷，安全。'
    ],
    accordions: [
      {
        name: 'technology',
        title: '专业人士',
        subtitle: '我们的主要财富',
        text: [
          '意识到与我们共同工作的人是我们最大的财富。寻求与我们分享价值观和理念的独特而富有创造力的人，他们理解律师事务不仅仅是书本和法律条款，需要有创业精神，在创新和效率上奔跑，渴望服务的个性化、专业化、道德还有关注和质量。'
        ]
      },
      {
        name: 'professionals',
        title: '合伙人',
        subtitle: '我们最成功的盟友',
        text: [
          '我们的客户遍布各地。在巴西我们几乎无处不在，为了实现这目标，在某些情况下我们采用的战略是选择合作伙伴，他们分享我们的理念，并以效率，敏捷性，创新和适当的成本满足我们的需求。这种做法可以降低我们的成本，因为它是需要时才使用的。'
        ]
      },
      {
        name: 'partners',
        title: '科技',
        subtitle: '我们最好的工具',
        text: [
          '法律、商业和技术的方面的结合是现代世界的有趣组合。我们是有远见的人，适应现代的新市场，始终致力于创新，为我们的客户及其业务提供安全、灵活、创新和高效的解决方案。这种不断追求新颖，超越了律师业务的需要，让我们认识市场上所提供的许多选项，使我们能够始终领先竞争对手一步。',
          '技术创新不仅仅是尖端的硬件和软件。我们需要组织与组合所有的于一个安全与平稳的环境，便于收索信息，使信息能够灵活高效流通。对创新的追求也是为了简化工作，例如纸张的使用，技术创新的优势使我们降低成本，降低对环境影响，提高信息管理的效率和安全性。'
        ]
      }
    ]
  },
  ready: {
    title: '为您准备好了',
    subtitle: '您业务的360°',
    paragraphs: [
      '我们致力于为客户提供我们卓越的经验。我们的成员都是法律专业，与您业务环境的市场、经济与政治的新颖性保持一致。这种组合使我们能够为您提供所需的商业建议，让您的机会最大化及克服您遇到的挑战。'
    ]
  },
  solutions: {
    title: '解决方案',
    subtitle: '100% 动手',
    paragraphs: [
      '为客户提供解决方案是我们最擅长的。我们拥有以简单有效的方式处理您业务的技能和经验，而且法律问题不一定是复杂的。'
    ],
    accordions: [
      {
        title: '培养业务',
        text: ['我们协助组建了多家公司。我们喜欢企业初期运转的能量。我们的理念是从业务开始就提供法律和商业愿景的结合 - 这是一种难得的支持。']
      },
      {
        title: '计时合约',
        text: ['不是每个人都需要聘请一名全职律师。为了满足偶尔的需求，通过创新的服务、质量、创造力、灵活性和便利性，可以聘请我们的律师以时间计算而且还可以提供上门服务。']
      },
      {
        title: '咨询',
        text: ['与传统法律相反的做法，我们寻求简化和创新的解决方案，以适当的价格提供效率和质量的服务。我们为您处理谈判、合同和其他问题或战略安排，让您能够专注于您本身的工作。我们也支持您自己的法律部门，我们已准备好为您和您的业务服务。']
      },
      {
        title: '诉讼',
        text: ['案件流程，听证会，上诉，仲裁，调解......我们都已经经历过这些！案件管理策略是我们的强项。它的费用不仅在您的预算范围内，也在您的目标和期望范围内。每个步骤的信息您都会知道。我们喜欢这种沟通。合同纠纷、破产、收款、欺诈、企业罪、执行税捐法、强制令，不竞争......您是老板：我们为您随时准备好了！']
      },
      {
        title: '危机管理',
        text: ['当危机时刻能够解危，您将需要有值得信赖的人围绕着您帮助您，这对您来说是决定性的。我们可以通过战略行动和创新，以创新的解决方案来消除杠在您肩头的压力。']
      }
    ]
  },
  performance: {
    title: '工作范围',
    subtitle: '我们总是走在前面 - 内容与策略',
    paragraphs: [
      '为客户提供解决方案是我们最擅长的。我们拥有以简单有效的方式处理您的业务的技能和经验，毕竟，法律问题没有必要是复杂的。请详细了解我们提供的服务：'
    ],
    accordions: [
      {
        title: '航空',
        subtitle: '进口飞机和零件;将公司的民事和税务诉讼纳入与航空事务有关的事宜;民事责任，对外国投资者的建议等等',
        text: ['航空法的主要来源分散于陆地商业法已经建立的各种法律机构中，这反应在现代航空运输中，且具有重大意义。']
      },
      {
        title: '合规',
        subtitle: '对付欺诈，腐败，非法行为及不同意公司的政策。',
        text: ['我们随时准备协助客户为他制定和构建风险控制和预防政策与机制。']
      },
      {
        title: '消费者',
        subtitle: '合同的制定，分析和谈判;有关此事的建议和意见，以防止后期的纠纷;帮助制定、包装等等',
        text: ['促进准备和基本预防的指导，制定在司法内和司法外的安全解决方案，是消费主义核心的目标。']
      },
      {
        title: '合同',
        subtitle: '购买，销售，谈判，合并，宪法，分析，战略，支持。',
        text: ['我们与客户一起发展量身定制的解决方案，了解客户的业务，评估客户的需求，为客户制定战略并分析所涉及的风险。参与所有谈判，从概念到条件的执行提供支持。我们创新、富有创造力、高效灵活，我们将法律和业务看法结合起来。我们积累了多样化的谈判经验，并制定了多样化和复杂的主题。我们准备好为您的业务带来最佳结果。']
      },
      {
        title: '家庭办公室和承传计划',
        subtitle: '个性化和创造性的解决方案。',
        text: ['不断的为客户寻求安全和降低成本，在财产组织中采取战略性行动，目标是提供最低的税收负担及结合有效的财产治理和管理。']
      },
      {
        title: '合并与收购',
        subtitle: '战略规划和执行。',
        text: ['购买，出售，合并，联合：这些操作充满了考虑因素和细节。无论您处于“桌面” 的那一边，让我们共同努力来了解您真正想要的东西，并从那里创建一个清晰客观的流程。我们始终与您并肩作战，从概念设计，战略规划和执行直到新阶段初始阶段的支持。']
      },
      {
        title: '经济犯罪',
        subtitle: '打击假冒和盗版; 指导和辩护，因逃税指控等引起的警方调查和/或刑事诉讼。',
        text: ['随着巴西经济的快步发展和处理腐败，常出现“白领犯罪者”、“领带犯罪者”及“富人犯罪者”，常常发生于商业界与企业界，由于经营者、董事或股东涉嫌商务或企业经营方面的犯罪，一般的不属于暴力，但涉及欺诈或违反信托，逃税等等。']
      },
      {
        title: '知识和艺术产权',
        subtitle: '作者的权利，人物的权利，商业表演和图像的权利。',
        text: ['今天对在知识和艺术财产相关的不同领域工作的专业人士来说，需要专业建议的协助。我们拥有一支能够有效服务客户的专业团队。']
      },
      {
        title: '处理争执的策略',
        subtitle: '谈判和决策。',
        text: ['我们的组织结构是为了帮助我们的客户进行多样化的谈判，为战略和高效的决策做出贡献。我们准备以更灵活，更经济的方式满足客户利益的需求;在仲裁庭为客户争取投票争议的替代方案。']
      },
      {
        title: '股东',
        subtitle: '公司的结构与成立、兼并、分拆、合并、战略联盟。',
        text: ['我们的客户群都是行业的领头羊，以及处于工商业各个发展阶段的企业，它们对我们的服务充满信心。联盟和合作伙伴关系政策更提高了我们团队的可信度，我们团队致力于构建创造、高效、创新和以业务为中心的解决方案，同时不忘提供卓越服务的重要，这种服务以敏捷、完整、差异化和个性化的方式进行。']
      },
      {
        title: '劳工法',
        subtitle: '合同和劳工文件的制定及谈判和协助、行政和司法诉讼、提供意见等',
        text: ['我们的结构是为了提供建议和参与预防、咨询和司法事务，我们积累了攻防经验并采用高明的策略，为法律的领域提供了广泛而合格的观点。']
      },
      {
        title: '税务法',
        subtitle: '咨询和规划，包括税金的奖励和减税;行政和司法诉讼等',
        text: ['我们的税务核心队伍完全有资格满足您为了国家税收的所有需求，在司法和行政诉讼领域采取强有力的参与。凭借丰富的知识，我们参与税务咨询业务，提供有关的广泛法律建议以及针对公司和个人经济的分析。']
      }
    ]
  },
  cases: {
    title: '成功的例子',
    subtitle: '您是我们的优先',
    paragraphs: [
      '保持透明的关系 - 专注于对每个客户的创新和个性化的处理 – 给我们的律师事务所带来巨大的信誉和信任。客户是我们理念的最高优先，我们努力产生积极和持久的结果，达到客户的期望和目标。通过这种方式来征服我们的市场，以下品牌对我们服务的认可：'
    ]
  },
  footer: {
    paragraph: '战略、智慧和创新的解决方案。法律和商业技能的神奇组合。我们的伙伴关系和奉献精神的基础是通过信任和友谊建立的密切、透明、坚实和持久关系。这是我们所热衷的。',
    medias: '我们的渠道',
    instagram: '最新的INSTAGRAM帖子',
    newsletter: {
      title: '最新的信息',
      paragraph: '请注册及接收来自法律界和Onesti律师的最新消息'
    },
    contact: {
      title: '让我们谈谈',
      placeholder: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Message'
      },
      buttonLabel: 'Send'
    },
    slogan: '我们属于我们所做的',
    links: [
      '現代奴隸制行為',
      '綠色政策',
      '反腐敗法案',
      '我們的政策'
    ],
    legalAdvice: '信息和法律'
  },
  disclaimer: [
    ' 策略性的、聪明的及创新的解决方案。一种法律技能与商业的神奇组合。以伙伴的关',
    '系和奉献精神为基础，以信任与友谊与客户建立密切、透明、稳固和持久的关系。这是',
    '我们所热衷的。',
    '此网页所提供的是Onesti advogados律师事务所的官方信息，只是一般的官方信息。',
    '注意网页是一个不怎么安全的环境，您的邮件可能被第三者截获而消息外泄。与我们',
    '电子联系，但是电子邮件不代表律师事务所与您签约。它的内容不能够视为法律上的',
    '建议。',
    '抄袭法律建议要注意，因为之前成功的案例不能保证类似案件的结果。',
    '专业协助：您不应使用本网站上的信息替代您的律师或其他专业法律服务提供的法律',
    '建议。如果您对法律问题有任何疑问或需要澄清，请通过我们的沟通渠道联系我们并',
    '安排面议。',
    '® Onesti Advogados CNPJ: 31.431.327/0001-41 | OAB/SP 27.583'
  ],
  email: {
    name: 'hello',
    highlightedWord: 'onesti',
    domain: 'law.com'
  },
  legalAdvice: {
    detail: {
      title: 'A detail oriented law firm',
      subtitle: 'We have as a fundamental basis for behavior and decision making in our office. We expect everyone with whom we do business, including suppliers, and customers to adhere to our principles.',
      paragraphs: [
        {
          hashTag: '#WeAreAllOnesti ',
          text: 'Regardless of who does, everyone is affected. What we do impacts directly on the image and reputation of the firm, so we always act based on our culture, guided by our principles and values. Honesty and integrity all the time and everywhere.'
        },
        {
          hashTag: '#WeAreProtagonistsofOurActs',
          text: 'We are responsible for the quality of our services, for serving our customers, for our decisions and actions.'
        },
        {
          hashTag: '#OurWordCounts',
          text: 'We treat everyone with honesty, integrity and clarity. Our word is worth a lot. Our billing method follows the same parameters. We arc with what we commit.'
        },
        {
          hashTag: '#TheLawIsOurNorth',
          text: 'We have the obligation to know, observe and apply the law in everything we do. We are a law firm that is aware of its role and its obligations, be it with the client, suppliers, employees and / or society in which we operate.'
        },
        {
          hashTag: '#WeLookForOurEquals',
          text: 'We know our customers, partners, suppliers and employees. We look for doing business with those who are in accordance with our culture, who share our principles and values.'
        },
        {
          hashTag: '#WePromoteHealthyCompetion',
          text: 'Healthy competition, with ethics and no cheating, is important to motivate the team to seek the highest performance possible. We encourage interpersonal relationships with fellowship, respect, integrity, and honesty.'
        },
        {
          hashTag: '#WeCelebrateAndSupportDifferences',
          text: 'Similarities and differences are sources of our strength. We are aware that diversity improves who we are, strengthening our ability to compete, adapt and change.'
        },
        {
          hashTag: '#WeAreAlsoGuardians',
          text: 'We are responsible for the security of the information we manipulate, and we must ensure that we treat all personal data in an appropriate manner and in accordance with our privacy policies. We must not disclose or make use of any confidential information of the client or the office, inside or outside the company, except in the proper performance of our services.'
        },
        {
          hashTag: '#ResponsibilityAndSeriousness',
          text: 'We act with ethics, in accordance with the statutes and codes that govern our profession.'
        },
        {
          hashTag: '#Gratitude',
          text: 'We foster a more just society by consciously using our resources and contributing to the community in which we operate through volunteer and pro bono work.'
        }
      ]
    },
    clarifications: {
      title: 'Our clarifications',
      introduction: 'Introduction. Thank you for using www.onestilaw.com, or any other website controlled and operated by Onesti Attorneys (individually, a "Site" or collectively, “Sites”). Onesti Attorneys (“firm”, “we”, “us” and “our”) is a law firm practicing in Brazil. Each Site contains general legal information based on Brazilian law and information about our legal services. These Terms and Conditions of Use (“Terms and Conditions”) represent a legally binding agreement between you and us and apply to your use of our Sites. By using any of our Sites, you acknowledge that you have read, understood and agree to comply with these Terms and Conditions and our Privacy Policy which is incorporated into these Terms and Conditions by reference. You also agree that any disputes or matters arising out of or related to your viewing or use of this Web site shall be governed under the laws of the Federative Republic of Brazil without regard to the conflict of laws. If you do not accept any of these terms, please do not use any of our Sites.',
      activityTitle: 'Advocacy is through activity',
      paragraphs: [
        'The content on this website is provided by Onesti Attorneys in good faith on an "as is" basis for general information purposes only, containing only general references on legal matters and is not intended to constitute or substitute legal or other professional advice. The reader should not consider this information to be an invitation to an attorney client relationship, should not rely on information presented here for any purpose, and should always seek the legal advice of counsel in the appropriate jurisdiction. It should be noted:  the hiring of a lawyer is an important decision that should not be based solely upon advertisements, written information about the qualifications or experience of that lawyer. No representation is made that the quality of the legal services to be performed is greater than the quality of legal services performed by other lawyers.',
        'You should also not consider this information, or randomly received emails, under any circumstances, as an attempt to attract customers. Nothing on this site constitutes a binding offer to perform any legal service in any jurisdiction.',
        'Please remember: By providing information to Onesti Attorneys through this site or by contacting us electronically in any other form, including through emails you are not establishing, creating nor soliciting a lawyer-client relationship and the information you provide will not receive adequate legal protection. This means that, although Onesti Attorneys protects confidentiality according to its policy, the information provided is not protected by laws related to Attorney-client privilege. In these circumstances, Onesti Attorneys may be required to disclose the information provided in certain legal proceedings and therefore you should not provide any information about your legal needs that you wish to protect by virtue of such legal privilege. It is never too much to point out that the internet is not necessarily a secure environment, and it is possible that your email will be intercepted and read by third parties.',
        'It is important to emphasize that we are very proud of the results we obtain for our clients, but you should know that advocacy is through activity, not an ending, and PRIOR RESULTS DO NOT GUARANTEE A SIMILAR OUTCOME. Since the law is constantly changing and since the law will vary based on different facts and circumstances, statements on this web site regarding the status of a given law or legal issue may not be current or applicable to your particular situation. Testimonials or endorsements do not constitute a guarantee, warranty, or prediction regarding the outcome of your legal matter. You should not take any action based on the information in this web site.',
        'All Attorneys in Onesti Advogados are registered at Brazilian Bar Association – OAB (available for consultation at: https://cna.oab.org.br/) and endeavor to comply with all legal and ethical requirements. Our firm is also registered at the Brazilian Bar Association (available for consultation at: https://cnsa.oab.org.br/ ) . Onesti Advogados maintains professional indemnity insurance for legal practices.  ',
        'If you have any questions or require clarification on legal issues, please contact and schedule a meeting through our communication channels.'
      ],
      subsections: [
        {
          title: 'Please Contact Us If You Would Like Us to Represent You',
          paragraphs: [
            'If you are interested in asking us to represent you, please call us, email us, or otherwise contact us so we can determine whether the matter is one for which we are willing or able to accept professional responsibility.  The telephone numbers for our offices are listed on our websites.  If you submit information to us by email or otherwise, you acknowledge that it will not be considered to be confidential absent an express written agreement by the Firm to maintain your information in confidence.  We reserve the right to decline any representation, and may be required to decline representation if it would create a conflict of interest with any of our current or former clients.   '
          ]
        },
        {
          title: 'Complaints Procedure',
          paragraphs: [
            `Onesti Attorneys is committed to providing high quality legal advice and client care.  If you are not satisfied with our service or have a complaint about a bill please contact the Partner responsible for your work. If you remain dissatisfied having discussed matters informally with the Partner responsible you are entitled to invoke our formal Complaints Procedure by contacting Murillo Onesti, our Compliance Officer for Legal Practice by telephone ${getPhoneNumber()}) or email (murillo.one@onestilaw.com).`
          ]
        },
        {
          title: 'E-mail Disclaimer',
          paragraphs: [
            'If you have received an e-mail from Onesti Attorneys at Law, the e-mail message and all attachments transmitted with it are intended solely for the use of the addressee and may contain legally privileged and confidential information. If the reader of the message is not the intended recipient, or an employee or agent responsible for delivering the message to the intended recipient, you are hereby notified that any dissemination, distribution, copying, or other use of the message or its attachments is strictly prohibited. If you have received a message in error, please notify the sender immediately by replying to the message and please delete it from your computer.'
          ]
        },
        {
          title: 'Links',
          paragraphs: [
            'This web site occasionally contains links to other web pages; however, the inclusion of such links does not constitute referrals or endorsements of the linked entities. Links to organizations and governmental agencies are provided as a convenience to our readers. The Firm does not endorse and is not responsible for any third-party content that may be accessed from its web site and does not recommend or endorse the use of any third-party’s services. The links are to be accessed at the user’s own risk, and the authors of this web site make no representations or warranties about the content of these links.'
          ]
        }
      ]
    },
    privacy: {
      title: 'Privacy statement',
      subtitle: 'Transparency',
      introduction: 'This Privacy Statement describes how Onesti Attorneys (the "Firm") collects, uses, shares, and otherwise processes Personal Data (defined below) about:',
      cookieUsageList: [
        'Visitors to our websites, mobile applications, and other online properties (each, a "Site");',
        'Contact persons for our clients and/or prospective clients;',
        'Contact persons for suppliers of goods and services to the Firm;',
        'Any other individuals about whom the Firm obtains Personal Data.'
      ],
      marketingTitle: 'Marketing Choices',
      paragraphs: [
        'You have control regarding our use of Personal Data for direct marketing. You can choose to not receive such communications at any time. If you no longer wish to receive any marketing communications, remain on a mailing list to which you previously subscribed, or receive any other marketing communication,  please follow the unsubscribe link in the relevant communication or contact us as per below.',
        'Please read the following statement, which sets out the principles governing the Firm’s use of personal information that we may obtain about you, to understand how the Firm collects, uses, and otherwise processes your personal information as well as the rights that you have in relation to our processing of that information (the “Privacy Statement”). ',
        'When you visit the Onesti Attorneys website, the Firm may have some information about you (your "personal information") and, in this case, collects, uses and is responsible for it. When we do this, we are the "controller" of this information for the purposes of applicable data protection laws.',
        'You may provide Personal Data to us by email, post, telephone, face to face during meetings or at our events or through our website',
        'We may collect your data indirectly or from third parties from your colleagues, social media, our network of contacts, others who may know you, event delegate lists or third-party market research, through recruitment agencies, social media searches (such as LinkedIn), research companies, client or supplier conversations, or referrals from other third parties.',
        'It is important to remember that you are not required to provide any personal information in the public areas of our site. However, you can choose to do so by filling out the application form (s). If you do, we may, for example, keep a record of your name, email address, and any other information you provide. We may supplement the information that you provide to us with information that we receive or obtain from other sources. We maintain data for varying periods, depending on its purpose:'
      ],
      dataUsageList: [
        {
          title: 'Recruitment:',
          text: 'Personal information about job applicants is collected and processed for purposes of screening, identifying, and evaluating candidates for positions; record-keeping related to hiring processes; analyzing the hiring process and outcomes; and conducting background checks, where and to the extent permitted by applicable law. If you are hired by the Firm, this data will be transferred to our employee record files for the purpose of your employment. In addition, job applicant data and legal and regulatory compliance data may be used as necessary to comply with legal, regulatory, and corporate governance requirements.'
        },
        {
          title: 'Email Alerts:',
          text: 'The personal information you provide to receive e-mail alerts will be maintained for a period of two years after your last interaction with us. You can choose not to receive email alerts at any time by contacting us or by clicking the unsubscribe link contained in an email you received.'
        },
        {
          title: 'Use of Information:',
          text: 'When you provide us information through this site, it will be processed by us or on our behalf, in accordance with the provisions of applicable data protection laws. If we store this data, it will be kept on digital media or in printed form. The personal information you submit will be used to resolve any questions you have or to notify you of our services or recruitment process. We may provide information about you (on the understanding that such information will be kept confidential) to partners, employees and agents of Onesti Attorneys to administer any service provided to you. We will only disclose your personal information to third parties if we have notified you in advance and in accordance with this notice except as follows: to comply with applicable laws and legal or governmental legal requests; operate our systems properly; or to protect our users and the firm.'
        }
      ],
      rightsSummary: 'In accordance with data protection laws, you have important rights. In short:',
      rights: {
        title: 'Your rights',
        rightsList: [
          'Fair processing of information and transparency about how we use your personal information to use;',
          'Access to your personal information and other supplementary information;',
          'Require the correction of any error in the personal information we have about you;',
          'Receive the personal information you have provided to us in a structured, commonly used and legible format that has the right to transmit such information to third parties in certain situations;',
          'Etc.'
        ],
        infoRights: [
          'For more information about each of these rights, including the circumstances in which they apply, there are guidelines available from the applicable data protection authorities.',
          'If you would like to exercise any of those rights, please:'
        ],
        emailListItem: 'Email us at: privacy@onesti.adv.br;',
        requiredDataListItem: {
          title: 'Remember to provide:',
          text: 'Enough information to identify yourself (eg name, email address); proof of your identity and address (a copy of your driver’s license or passport and a recent utility or credit card bill); and the information to which your request relates. '
        },
        paragraphs: [
          {
            title: 'Security',
            text: ['We endeavor to take all reasonable steps to protect your personal information, but cannot guarantee the security of any data you disclose online. Please note that email is not a secure medium and should not be used to send confidential or sensitive information. By providing information online, you accept the inherent security risks of providing information over the Internet and will not hold us responsible for any breach of security, unless it is due to our negligence or willful default.']
          },
          {
            title: 'Data sharing and transfer',
            text: ['Any information received by us through this site, including your personal information, may be transferred to or shared across our integrated computer networks with one or more of our affiliated offices in Brazil. ']
          },
          {
            title: 'Future Processing',
            text: ['We do not intend to process your personal information for any reason that is not stated in this Privacy Statement. If this changes, with registration of your registration, we will inform you by email.']
          },
          {
            title: 'Other sites',
            text: ['Please note that the Privacy Statement covers Onesti Advogados website only. We are not responsible for the data policies or procedures or content of any linked websites. We recommend that you check the privacy and security policies of each website you visit.']
          },
          {
            title: 'Notification of changes',
            text: ['We may update this Privacy & Cookies Statement from time to time as our services and privacy practices change, or as required by law.  We will post the updated version of the Privacy Statement on our Sites. We will not, however, significantly change the way we use the information you have provided to us without your prior agreement, if legally required. We encourage you to visit our Sites periodically to stay informed about our privacy practices. ']
          },
          {
            title: 'Google Analytics',
            text: [
              'We do not use cookies. However, we do use website tracking services such as Google Analytics which does use analytical and tracking cookies. By using this website, you consent to cookies being used in accordance with this statement. Google Analytics is Google\'s free web analytics tool that helps us understand how our visitors engage with our website. Google Analytics collects information anonymously and, much like examining footprints in sand, it reports website trends without identifying individual visitors. Analytics uses its own set of cookies to track visitor interactions. These cookies are used to store information, such as what time the current visit occurred, whether the visitor has been to the site before and what site referred the visitor to the web page. Google Analytics customers can view a variety of reports about how visitors interact with their website so that they can improve their website and how people find it. A different set of cookies is used for each website and visitors are not tracked across multiple sites. Google Analytics customers are obliged to notify users of their use of analytics software and this statement is our notification to you. To disable this type of cookie, some browsers will indicate when a cookie is being sent and allow you to decline cookies on a case-by-case basis. In addition to declining cookies, you can also install the Google Analytics Opt-out Add-on in your browser, which prevents Google Analytics from collecting information about your website visits. To learn more about the use of cookies for Google analytics and to exercise choice regarding such cookies, please',
              'Click here.'
            ]
          },
          {
            title: 'Liability',
            text: ['The Firm assumes no responsibility for computer viruses resulting from use of our web site. Under no circumstances, including, but not limited to, negligence, shall the Firm be liable for any special or consequential damages that result from the use of, or the inability to use, the materials in this web site, even if the Firm has been advised of the possibility of such damages.']
          },
          {
            title: 'Indemnification',
            text: ['You agree to indemnify, defend and hold harmless the Firm and its members, managers, officers, employees, agents and the assigns of same, from and against any and all loss, costs, expenses (including reasonable attorneys’ fees and expenses), claims, damages and liabilities related to or associated with your use of the web site and any violation of these Terms and Conditions by you.']
          }
        ]
      },
      reproduction: {
        title: 'Copyright and reproduction',
        subtitle: 'Rights are reserved',
        paragraphs: [
          'Copyright © 2019 Onesti Attorneys. All rights reserved. The content of the Onesti Attorneys at Law websites is protected by international copyright conventions. Reproduction of reasonable portions of the content of the sites is permitted provided that (a) the part of the website being reproduced is not altered or made available in a manner that modifies the content of the site and (b)such reproductions are made available for free and for non-commercial purposes, (c)such reproductions are properly attributed to Onesti Attorneys, (d) this notice is made for the disclaimers included on the site. location on the Internet.  The permission to re-copy does not allow for incorporation of any substantial portion of the web sites in any work or publication, whether in hard copy, electronic or any other form or for commercial purposes.',
          `We name as contact in Brazil the headquarters in the city of São Paulo, SP, located at Avenida Paulista, nº 91, 1º andar, 101, Bela Vista 01310-100. ${getPhoneNumber()} e-mail: privacidad@onesti.adv.br`
        ]
      }
    },
    grateful: {
      title: 'We are grateful',
      subtitle: 'Credits',
      paragraphs: [
        'We know that nothing is built alone and so we appreciate immensely to all those who participated in the construction of this website.The results were achieved through the commitment of all those who were engaged in search of a common goal, to build a website that could pass the philosophy, values and ideals of Onesti Lawyers. We are grateful and privileged to count on you!'
      ],
      conception: 'Conception',
      layout: 'Layout',
      programming: 'Programming',
      portugueseRevision: 'Portuguese revision',
      english: 'English translation',
      spanish: 'Spanish translation',
      chinese: 'Chinese translation',
      accessory: 'Accessory'
    },
    translation: {
      title: 'Translation in other languages',
      subtitle: 'Original version in portuguese',
      paragraphs: ['IMPORTANT: The content of this page (INFO & LEGAL) has been translated by machine translation software and not by a human translator and for this reason may contain errors in vocabulary, syntax or grammar similar to mistakes made by a foreign speaker. Onesti Attorneys is not responsible for any inaccuracies, errors or damages caused by a bad translation of the content or its use by our visitors. Access here the original Portuguese version. This document was last updated January 2019.']
    }
  },
  alt: {
    logo: '商標',
    qr: 'QR碼ONESTI法律公司聯繫',
    imagen: '客戶圖片',
    Instagram: 'Instagram帖子'
  }
}
